var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CHECK_CALL_SCHEDULED_FAILED, CLEAR_MESSAGE, } from './SeniorCallScheduler.action';
var INITIAL_STATE = {
    checkCallScheduledMessage: '',
};
export var seniorCallSchedulerReducer = function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case CHECK_CALL_SCHEDULED_FAILED:
            return __assign(__assign({}, state), { checkCallScheduledMessage: action.payload });
        case CLEAR_MESSAGE: {
            return __assign(__assign({}, state), { checkCallScheduledMessage: '' });
        }
        default:
            return state;
    }
};
